import { render, staticRenderFns } from "./RemoveFieldPopup.vue?vue&type=template&id=6f183a71"
import script from "./RemoveFieldPopup.vue?vue&type=script&lang=js"
export * from "./RemoveFieldPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports